export const RECALL_STATUSES = [
    { value: 'ALL', label: 'All statuses' },
    { value: 'PENDING', label: 'Pending' },
    { value: 'IN_PROCESS', label: 'In process' },
    { value: 'COMPLETED', label: 'Completed' },
    { value: 'FAILED', label: 'Failed' },
];

export const RECALL_SORT_FIELDS = [
    { value: 'createdAt', label: 'Created date' },
    { value: 'modifiedAt', label: 'Modified date' },
    { value: 'title', label: 'Title' },
    { value: 'status', label: 'Status' },
];

export const RECALL_SEARCH_FIELDS = [
    { value: 'title', label: 'Title' },
    { value: 'notes', label: 'Notes' },
    { value: 'adminNotes', label: 'Admin notes' },
];

export const DEFAULT_RECALL_FILTERS = {
    searchField: 'title',
    searchTerm: '',
    status: 'ALL',
    dateFrom: '',
    dateTo: '',
};

export const DEFAULT_RECALL_SORT = {
    sortBy: 'createdAt',
    sortOrder: 'DESC',
};

export const RECALL_STATUS_META = {
    PENDING: { className: 'recall-status--pending', icon: 'bi-hourglass-split', label: 'Pending' },
    IN_PROCESS: { className: 'recall-status--in-process', icon: 'bi-arrow-repeat', label: 'In process' },
    COMPLETED: { className: 'recall-status--completed', icon: 'bi-check-circle-fill', label: 'Completed' },
    FAILED: { className: 'recall-status--failed', icon: 'bi-x-circle-fill', label: 'Failed' },
};

export const RECALL_ALLOWED_EXTENSIONS = ['csv', 'doc', 'docx', 'pdf'];

export const formatRecallCount = (value) => {
    const number = Number(value);
    return Number.isFinite(number) ? number.toLocaleString() : '0';
};

export const formatRecallStatusLabel = (status) => {
    if (!status) {
        return 'Unknown';
    }

    return RECALL_STATUS_META[status]?.label
        || status
            .split('_')
            .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
            .join(' ');
};

export const getActiveRecallFilterChips = (filters) => {
    const chips = [];

    if (filters.searchTerm?.trim()) {
        const fieldLabel =
            RECALL_SEARCH_FIELDS.find((field) => field.value === filters.searchField)?.label || 'Search';

        chips.push({ key: 'searchTerm', label: `${fieldLabel}: ${filters.searchTerm.trim()}`, clearValue: '' });
    }

    if (filters.status && filters.status !== 'ALL') {
        chips.push({
            key: 'status',
            label: `Status: ${formatRecallStatusLabel(filters.status)}`,
            clearValue: 'ALL',
        });
    }

    if (filters.dateFrom) {
        chips.push({ key: 'dateFrom', label: `From: ${filters.dateFrom}`, clearValue: '' });
    }

    if (filters.dateTo) {
        chips.push({ key: 'dateTo', label: `To: ${filters.dateTo}`, clearValue: '' });
    }

    return chips;
};

export const countActiveRecallFilters = (filters) => getActiveRecallFilterChips(filters).length;

export const hasUploadedFile = (request) => {
    const path = request?.filePath;
    return Boolean(path && path !== 'NO_PATH');
};

export const canUploadRecallFile = (request) =>
    request?.status === 'PENDING' && !hasUploadedFile(request);

export const isAllowedRecallFile = (file) => {
    if (!file?.name) {
        return false;
    }

    const extension = file.name.split('.').pop()?.toLowerCase();
    return RECALL_ALLOWED_EXTENSIONS.includes(extension);
};

export const extractFileName = (filePath) => {
    if (!filePath || filePath === 'NO_PATH') {
        return null;
    }

    const parts = filePath.split('/');
    return parts[parts.length - 1] || filePath;
};

export const hasInitialReport = (request) => Boolean(request?.initialReportPath);

export const canDownloadInitialReport = (request) =>
    hasInitialReport(request) || ['IN_PROCESS', 'COMPLETED'].includes(request?.status);

export const getInitialReportFileName = (request, reqId) =>
    extractFileName(request?.initialReportPath) || `recall-initial-report-${reqId}.pdf`;
